import { CREATE_CLUB, GET_CLUBS } from 'constants/actionTypes';
import Fetch from 'helpers/fetch';

export const createClub = body => async (dispatch, getState) => {
  const { auth } = getState();

  const NFToken = auth.user.associatedAccounts?.find(
    ({ typeId, subTypeId }) => typeId === 16 && subTypeId === 101,
  )?.token;

  const { result } = await Fetch.POST(`/matchPoker/createClub`, {
    action: CREATE_CLUB,
    headers: { 'x-access-token': NFToken },
    body,
  });

  return result;
};

export const fetchClubs = () => async (dispatch, getState) => {
  const { auth } = getState();

  const NFToken = auth.user.associatedAccounts?.find(
    ({ typeId, subTypeId }) => typeId === 16 && subTypeId === 101,
  )?.token;

  const { result } = await Fetch.GET(`/matchPoker/getClubs`, {
    action: GET_CLUBS,
    headers: { 'x-access-token': NFToken },
  });

  return result;
};
